import { useState } from 'react';
import type { FAQ } from '@/mocks/faqs';

interface FAQSectionProps {
  faqs: FAQ[];
}

export default function FAQSection({ faqs }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const schemaFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaFAQ) }}
      />
      <div className="space-y-3">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-background-200/70 rounded-lg overflow-hidden bg-background-50"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              aria-expanded={openIndex === index}
            >
              <span className="text-sm font-medium text-foreground-900 pr-4">
                {faq.question}
              </span>
              <i
                className={`text-foreground-500 text-lg transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}
              ></i>
            </button>
            <div
              className={`transition-all duration-300 overflow-hidden ${
                openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
              }`}
            >
              <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}